import { createRequest, RequestConfig } from 'app/common/api';

import { TTrip, TWagonSeat } from '../core/trips';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_trip',
};

export const updateTripRequest = ({
  trip,
  seats,
}: {
  trip: Partial<TTrip>;
  seats?: TWagonSeat[];
}) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify({ trip, seats }),
  });
